<div
  class="input-container"
  data-testid="multi-select-autocomplete-editor-container"
>
  <div class="input-wrapper">
    <textarea
      #inputWithOptions
      [attr.aria-label]="placeholder"
      class="multi-select-textarea"
      [formControl]="searchControl"
      [placeholder]="placeholder"
      [maxlength]="maxLength"
      [style.width.px]="cellWidth"
      data-testid="multi-select-autocomplete-editor-input"
      (input)="enforceInputLimit()"
      [matAutocomplete]="auto"
    ></textarea>

    @if (searchControl.value?.length) {
    <mat-icon
      class="clear-icon"
      tabindex="0"
      role="button"
      data-testid="multi-select-autocomplete-clear-icon"
      (click)="clearInput($event)"
      (keydown.enter)="clearInput($event)"
      >close</mat-icon
    >
    }

    <mat-autocomplete
      #auto="matAutocomplete"
      [panelWidth]="autocompletePanelWidth"
      [class]="
        autocompletePanelClass +
        (noResults() ? ' custom-autocomplete--no-results' : '')
      "
    >
      <div class="options-container" (scroll)="onScroll($event)">
        <mat-option
          *ngFor="let option of filteredOptions$ | async"
          class="multi-select-option"
          [class.selected-option]="isSelected(option)"
          [value]="option"
        >
          <div
            class="multi-select-option-content"
            tabindex="-1"
            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
            (click)="onOptionItemClick(option, $event)"
            (keydown.enter)="onOptionItemClick(option, $event)"
          >
            <mat-checkbox
              class="multi-select-checkbox"
              color="primary"
              [checked]="isSelected(option)"
              [disabled]="isSelectionLimitReached(option)"
              (mousedown)="$event.preventDefault()"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (change)="toggleOption(option, $event)"
            >
            </mat-checkbox>

            <div class="autocomplete-option">
              <div class="autocomplete-option-primary">
                {{ optionDisplayWith(option).primary }}
              </div>

              @if (optionDisplayWith(option).secondary) {
              <div class="autocomplete-option-secondary">
                {{ optionDisplayWith(option).secondary }}
              </div>
              }
            </div>
          </div>
        </mat-option>

        @if(loader()){
        <mat-option
          class="loader-option"
          data-testid="multi-select-autocomplete-loader"
        >
          <div class="center">
            <mat-spinner diameter="20"></mat-spinner>
            @if (loaderText) {
            <div>{{ loaderText }}</div>
            }
          </div>
        </mat-option>
        }@if (!loader() && minSearchError()) {
        <mat-option disabled class="no-results-option">
          {{ minSearchError() }}
        </mat-option>
        } @if (!loader() && showNoResultsOption && noResults()) {
        <mat-option
          class="no-results-option"
          disabled
          data-testid="multi-select-autocomplete-no-results"
        >
          {{ noResultsText }}
        </mat-option>
        }
      </div>
    </mat-autocomplete>
  </div>
</div>
